import { useState, useEffect, useContext, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";
import normalize from "../utils/NormalizeSelect";

const MerchantGroups = () => {
  const [data, setData] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [group, setGroup] = useState({});
  const [popup, setPopup] = useState("");
  const [error, setError] = useState({});
  const [selectedMerchants, setSelectedMerchants] = useState([]);
  const [editedMerchants, setEditedMerchants] = useState([]);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const fileInputRef = useRef(null);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;
  const fetchMerchants = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}all-merchants?`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setMerchants(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchMerchantGroups = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}all-merchant-groups?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const openPopup = (action, data) => {
    const tempMerchants = [];
    const prevMerchants = data?.merchantList?.split(",");

    merchants.map((item) => {
      if (prevMerchants.includes(item._id)) {
        tempMerchants.push({
          label: item.merchantName,
          value: item._id,
        });
      }
    });
    setEditedMerchants(tempMerchants);
    setGroup(data);
    setPopup(action);
  };
  const processData = (type, event, field) => {
    if (type === "file") {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64 = reader.result.split(",")[1];
          const extensionMatch = file.name.match(/\.([^.]+)$/);
          const extension = extensionMatch[1].toLowerCase();
          const fileName = file.name;
          const fileObject = {
            type: extension,
            content: base64,
            fileName: fileName,
          };
          axios
            .post(
              process.env.REACT_APP_API_ENDPOINT + "upload-file",
              {
                file: fileObject,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((res) => {
              const newGroupData = { ...group };
              newGroupData[field] = res.data.data;
              setGroup({ ...newGroupData });
            })
            .catch((error) => {
              console.error(error);
            });
        };
        reader.readAsDataURL(file);
      }
    }
  };
  const addGroup = () => {
    const errors = {};
    if (group.name === undefined || group.name === "") {
      errors["name"] = "Please Enter Group Name";
    }
    if (group.logo === undefined || group.logo === "") {
      errors["logo"] = "Please Upload Logo";
    }
    if (group.merchantList === undefined || group.merchantList === "") {
      errors["merchantList"] = "Please Select Merchant";
    }

    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.logo === undefined &&
      errors.merchantList === undefined
    ) {
      axios
        .post(
          process.env.REACT_APP_API_ENDPOINT + "create-merchant-group",
          group,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setPopup("");
              setGroup({});
              setError({});
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              fetchMerchantGroups();
            }
          }
          reset();
        })
        .catch(console.error);
    }
  };
  const editGroup = () => {
    const errors = {};
    if (group.name === undefined || group.name === "") {
      errors["name"] = "Please Enter Group Name";
    }
    if (group.logo === undefined || group.logo === "") {
      errors["logo"] = "Please Upload Logo";
    }
    if (group.merchantList === undefined || group.merchantList === "") {
      errors["merchantList"] = "Please Select Merchant";
    }
    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.logo === undefined &&
      errors.merchantList === undefined
    ) {
      axios
        .post(
          process.env.REACT_APP_API_ENDPOINT + "edit-merchant-group",
          group,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setPopup("");
              setGroup({});
              setError({});
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              fetchMerchantGroups();
            }
          }
        })
        .catch(console.error);
    }
  };
  const deleteGroup = () => {
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "delete-merchant-group",
        group,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setGroup({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchMerchantGroups();
          }
        }
      })
      .catch(console.error);
  };
  const reset = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setSelectedMerchants([]);
    setGroup({});
    setError({});
  };
  useEffect(() => {
    fetchMerchants();
  }, []);
  useEffect(() => {
    fetchMerchantGroups();
  }, [page, search]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Merchant Groups
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}
            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <div className="row">
                  <div className="col-md-5 mb-3">
                    {/*begin::Card*/}
                    <PermissionGate required={`view_merchant_group`}>
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header border-0 pt-6">
                          {/*begin::Search*/}
                          <div className="w-100 my-1">
                            <input
                              type="text"
                              data-kt-user-table-filter="search"
                              className="form-control w-100"
                              placeholder="Search Groups"
                            />
                          </div>
                          {/*end::Search*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div className="card-body py-4 text-center">
                          {data && data.length > 0 ? (
                            <div className="table-responsive">
                              <table
                                className="table align-middle table-row-dashed fs-6 gy-5"
                                id="kt_table_users"
                              >
                                <thead>
                                  <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                    <th className="text-center min-w-100px">
                                      Group Logo
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Group Name
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  className="text-gray-600 fw-semibold"
                                  id="filterDataWrap"
                                >
                                  {data &&
                                    data?.map((item, index) => {
                                      return (
                                        <tr key={index} className="text-center">
                                          <td>
                                            {/*begin:: Avatar */}
                                            <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                              <div>
                                                <div className="symbol-label">
                                                  <img
                                                    src={
                                                      process.env
                                                        .REACT_APP_API_PUBLIC_URL +
                                                      item?.logo
                                                    }
                                                    alt={item?.name}
                                                    className="w-100"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            {/*end::Avatar*/}
                                          </td>
                                          <td>
                                            {/*begin::User details*/}
                                            <div className="d-flex">
                                              <span className="text-gray-800 text-hover-primary">
                                                {item?.name}
                                              </span>
                                            </div>
                                            {/*begin::User details*/}
                                          </td>
                                          <td className="">
                                            <div className="btn-group">
                                              {/*begin::Edit*/}
                                              <PermissionGate
                                                required={`edit_merchant_group`}
                                                fallback={<></>}
                                              >
                                                <button
                                                  onClick={() => {
                                                    openPopup(
                                                      "edit-group",
                                                      item
                                                    );
                                                  }}
                                                  className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                                  title="Edit"
                                                >
                                                  <i className="bi-duotone bi-pen fs-5"></i>
                                                </button>
                                              </PermissionGate>
                                              {/*end::Edit*/}
                                              {/*begin::Delete*/}
                                              <PermissionGate
                                                required={`delete_merchant_group`}
                                                fallback={<></>}
                                              >
                                                <button
                                                  onClick={() => {
                                                    openPopup(
                                                      "delete-group",
                                                      item
                                                    );
                                                  }}
                                                  className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                                  title="Delete Group"
                                                >
                                                  <i className="bi-duotone bi-trash fs-5"></i>
                                                </button>
                                              </PermissionGate>
                                              {/*end::Delete*/}
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-center w-100">
                              <img
                                className="w-25 mx-auto py-20"
                                src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                                alt="no-content"
                              />
                            </div>
                          )}
                          {/*begin::Paginate*/}
                          {count && Math.ceil(count / limit) > 1 ? (
                            <Pagination
                              page={page}
                              setPage={setPage}
                              count={count}
                              limit={limit}
                            />
                          ) : (
                            ""
                          )}
                          {/*end::Paginate*/}
                        </div>
                        {/*end::Card body*/}
                      </div>
                    </PermissionGate>
                    {/*end::Card*/}
                  </div>
                  <div className="col-md-7 mb-3">
                    {/*begin::Card*/}
                    <div className="card px-3">
                      {/*begin::Card header*/}
                      <div className="card-header">
                        {/*begin::Card title*/}
                        <div className="card-title">Add Merchant Group</div>
                        {/*begin::Card title*/}
                      </div>
                      {/*end::Card header*/}

                      {/*begin::Card body*/}
                      <PermissionGate required={`create_merchant_group`}>
                        <div className="card-body py-4">
                          <form
                            id="merchant_group_form"
                            method="post"
                            encType="multipart/form-data"
                          >
                            <div className="row">
                              <div className="col-md-6">
                                <label className="form-label required">
                                  Group Name
                                </label>
                                <input
                                  value={group?.name ?? ""}
                                  onChange={(e) => {
                                    setGroup({
                                      ...group,
                                      name: e.target.value,
                                    });

                                    setError({ ...error, name: "" });
                                  }}
                                  autoComplete="off"
                                  id="group_name"
                                  className="form-control"
                                  placeholder="Enter Group Name"
                                />
                                <div
                                  className="text-danger"
                                  id="group_name_error"
                                ></div>
                              </div>
                              <div className="col-md-6">
                                <label className="form-label required">
                                  Group Icon
                                </label>
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  onChange={(e) => {
                                    processData("file", e, "logo");
                                    setError({ ...error, logo: "" });
                                  }}
                                  id="group_image"
                                  className="form-control"
                                />
                                <div
                                  className="text-danger"
                                  id="group_image_error"
                                ></div>
                              </div>
                            </div>
                            <div className="row mt-4">
                              <div className="col-md-12">
                                <label className="form-label required">
                                  Select Merchant
                                </label>
                                <Select
                                  className="react-select-styled react-select-bordered"
                                  classNamePrefix="react-select"
                                  value={selectedMerchants}
                                  onChange={(merchant) => {
                                    setSelectedMerchants(merchant);
                                    const merchantList = [];
                                    merchant.map((item) => {
                                      merchantList.push(item.value);
                                    });
                                    setGroup({
                                      ...group,
                                      merchantList: merchantList.join(","),
                                    });

                                    setError({
                                      ...error,
                                      merchantList: "",
                                    });
                                  }}
                                  options={merchants?.map((item) => {
                                    return {
                                      value: item._id,
                                      label: item.merchantName,
                                    };
                                  })}
                                  filterOption={(option, input) => {
                                    return normalize(option.label).includes(normalize(input));
                                  }}
                                  placeholder="Select an option"
                                  isMulti={true}
                                  closeMenuOnSelect={false}
                                />
                                <div
                                  className="text-danger"
                                  id="merchant_list_error"
                                ></div>
                              </div>
                            </div>
                            {/*begin::Actions*/}
                            <div className="d-flex flex-row-fluid pt-12">
                              <button
                                onClick={reset}
                                type="button"
                                className="btn btn-sm btn-secondary me-3"
                              >
                                Clear
                              </button>

                              <button
                                onClick={addGroup}
                                type="button"
                                className="btn btn-primary btn-sm"
                              >
                                Add
                              </button>
                            </div>
                            {/*end::Actions*/}
                          </form>
                        </div>
                      </PermissionGate>
                      {/*end::Card body*/}
                    </div>
                    {/*end::Card*/}
                    {/*begin::Container*/}
                    <div
                      id=""
                      className="d-flex flex-column-fluid align-items-start  container-xxl "
                    >
                      {/*begin::Post*/}
                      <div className="content flex-row-fluid" id=""></div>
                      {/*begin::Modal - Edit Group*/}
                      <div
                        className={
                          popup === "edit-group"
                            ? "modal fade show d-block"
                            : "modal fade"
                        }
                        tabIndex="-1"
                        id="editGroupModal"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded">
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Close*/}
                              <h4>Edit Group</h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <form
                                id="merchant_group_form"
                                method="post"
                                encType="multipart/form-data"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <label className="form-label required">
                                      Group Name
                                    </label>
                                    <input
                                      value={group?.name ?? ""}
                                      onChange={(e) => {
                                        setGroup({
                                          ...group,
                                          name: e.target.value,
                                        });

                                        setError({ ...error, name: "" });
                                      }}
                                      autoComplete="off"
                                      id="group_name"
                                      className="form-control"
                                      placeholder="Enter Group Name"
                                    />
                                    <div
                                      className="text-danger"
                                      id="group_name_error"
                                    ></div>
                                  </div>
                                  <div className="col-md-6">
                                    <label className="form-label required">
                                      Group Icon
                                    </label>
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      onChange={(e) => {
                                        processData("file", e, "logo");
                                        setError({ ...error, logo: "" });
                                      }}
                                      id="group_image"
                                      className="form-control"
                                    />
                                    <div
                                      className="text-danger"
                                      id="group_image_error"
                                    ></div>
                                  </div>
                                </div>
                                <div className="row mt-4">
                                  <div className="col-md-12">
                                    <label className="form-label required">
                                      Select Merchant
                                    </label>
                                    <Select
                                      className="react-select-styled react-select-bordered"
                                      classNamePrefix="react-select"
                                      value={editedMerchants}
                                      onChange={(merchant) => {
                                        setEditedMerchants(merchant);
                                        const merchantList = [];
                                        merchant.map((item) => {
                                          merchantList.push(item.value);
                                        });
                                        setGroup({
                                          ...group,
                                          merchantList: merchantList.join(","),
                                        });

                                        setError({
                                          ...error,
                                          merchantList: "",
                                        });
                                      }}
                                      options={merchants?.map((item) => {
                                        return {
                                          value: item._id,
                                          label: item.merchantName,
                                        };
                                      })}
                                      filterOption={(option, input) => {
                                        return normalize(option.label).includes(normalize(input));
                                      }}
                                      placeholder="Select an option"
                                      isMulti={true}
                                      closeMenuOnSelect={false}
                                    />
                                    <div
                                      className="text-danger"
                                      id="merchant_list_error"
                                    ></div>
                                  </div>
                                </div>
                                {/*begin::Actions*/}
                                <div className="d-flex flex-row-fluid pt-12">
                                  <button
                                    onClick={() => {
                                      setGroup({});
                                      setError({});
                                      setPopup("");
                                    }}
                                    type="button"
                                    className="btn btn-sm btn-secondary me-3"
                                  >
                                    Close
                                  </button>

                                  <button
                                    onClick={editGroup}
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                  >
                                    Update
                                  </button>
                                </div>
                                {/*end::Actions*/}
                              </form>
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                      {/*end::Modal - Edit Group*/}

                      {/*begin::Modal - Delete Group*/}
                      <div
                        className={
                          popup === "delete-group"
                            ? "modal fade show d-block"
                            : "modal fade"
                        }
                        tabIndex="-1"
                        id="deleteGroupModal"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded bg-danger text-light">
                            {/*begin::Modal header*/}
                            <div className="modal-header text-center text-light">
                              {/*begin::Close*/}
                              <h4 className="mx-auto text-light">
                                DELETE GROUP
                              </h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <h4 className="text-center my-5 text-light">
                                Are You Sure ?
                              </h4>

                              {/*begin::Actions*/}
                              <div className="d-flex flex-row-fluid justify-content-center pt-3">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary me-3"
                                  onClick={() => {
                                    setGroup({});
                                    setError({});
                                    setPopup("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  onClick={deleteGroup}
                                  type="button"
                                  className="btn btn-light btn-sm"
                                  id="kt_modal_upgrade_plan_btn"
                                >
                                  {/*begin::Indicator label*/}
                                  <span className="indicator-label">
                                    Delete
                                  </span>
                                  {/*end::Indicator label*/}
                                  {/*end::Indicator progress*/}
                                </button>
                              </div>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                      {/*end::Modal - Delete Group*/}
                      {/*end::Post*/}
                    </div>
                  </div>
                </div>
              </div>
              {/*end::Post*/}
            </div>
          </div>

          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default MerchantGroups;
